<template>
  <section v-maximizable>
    <div class="table-tab">
    <div class="table-tab__actions-block" v-if="canEditRules">
      <table class="table-tab__block table" style="width: 140px">
        <thead class="table-tab__thead">
        <tr class="table-tab__row-auto-height">
          <th>{{$t('labels.actions')}}</th>
        </tr>
        </thead>
        <tbody class="table-tab__tbody">
        <template  v-for="(item, rowId) in info">
          <tr class="table-tab__row-auto-height table-tab__tr table-tab__tr-border">
            <template v-if="item.editable">
              <th class="table-tab__actions table-tab__actions--redaction u-align-items-start">
                <div class="table-tab__actions">
                  <button type="button" @click="confirmEditable(rowId)" :title="$t('buttons.save')">
                    <img class="table-tab__img-4" src="@/assets/img/static/tab-ok.svg" alt="">
                  </button>
                  <button type="button" @click="cancelEditable(rowId)" :title="$t('buttons.cancel')">
                    <img class="table-tab__img-5" src="@/assets/img/static/tab-close.svg" alt="">
                  </button>
                </div>
              </th>
            </template>
            <template v-else>
              <th class="table-tab__actions">
                <div class="table-tab__actions">
                  <button type="button" :title="$t('buttons.modify')" @click="editItem(rowId)" :disabled="hasEditable">
                    <img class="table-tab__img-1" src="@/assets/img/static/b-icon_edit.svg" alt="">
                  </button>
                  <button type="button"  :title="$t('buttons.delete')" @click="deleteItem(rowId)" :disabled="hasEditable">
                    <img class="table-tab__img-3" src="@/assets/img/static/trashcan.svg" alt="">
                  </button>
                </div>
              </th>
            </template>
          </tr>
        </template>
        </tbody>
      </table>
    </div>

    <div class="table-tab__container"
         style="overflow: auto; overflow-x: auto; outline: none;"
         :style="`max-width: calc(100% - ${canEditRules ? '140px': 0})`">
      <table class="table-tab__block table " style="width: 2000px">
        <thead class="table-tab__thead">
          <tr class="table-tab__row-auto-height">
            <th class="table-tab__width-90 table-tab__th--row">№</th>

            <th style="width: 140px">{{$t('form.catalogs.catalog-type.present-price.table.resident')}}</th>
            <th style="width: 300px">{{$t('form.catalogs.catalog-type.present-price.table.bid-currency')}}</th>
            <th style="width: 150px">{{$t('form.catalogs.catalog-type.present-price.table.payment-currency')}}</th>
            <th style="width: 300px">{{$t('form.catalogs.catalog-type.present-price.table.contract-currency')}}</th>
<!--            <th class="table-tab__border-right " style="width: 150px">{{$t('form.catalogs.catalog-type.present-price.table.fix-currency')}}</th>-->
            <th class="table-tab__width-180">{{$t('form.catalogs.catalog-type.present-price.table.price-forming-description')}}</th>
            <th>{{$t('form.catalogs.catalog-type.present-price.table.price-forming')}}</th>
            <th>Подсказка участнику по варианту формирования цены и валюты</th>
            <th style="width: 160px">{{$t('form.catalogs.catalog-type.present-price.table.currency-clause')}}</th>
            <th style="width: 300px">{{$t('form.catalogs.catalog-type.present-price.table.fix-date')}}</th>
            <th style="width: 300px">{{$t('form.catalogs.catalog-type.present-price.table.payment-date')}}</th>
            <th >Возможность аванса</th>

            <th class="table-tab__width-140"></th>
          </tr>
          </thead>
        <tbody class="table-tab__tbody">
          <template v-for="(item, i) of info">
            <tr class="table-tab__tr-border table-tab__row-auto-height">
              <template v-if="item.editable">
                <th class="table-tab__th table-tab__th--row">
                  {{i + 1}}
                </th>

                <td>
                  <dropdown-new class="select-w-120"
                                :options="enums.CatalogPersonStatus.options.all"
                                v-model="item.status">>
                  </dropdown-new>
                </td>
                <td>
                  <dropdown-new class="select-w-140"
                                :options="[
                                  { id: enums.BynOrAnotherCurrency.BYN, name: 'currency.byn'},
                                  { id: enums.BynOrAnotherCurrency.NOT_BYN, name: 'currency.not-byn'}
                                ]"
                                v-model="item.bidCurrency">
                  </dropdown-new>
                </td>
                <td>
                  <dropdown-new class="select-w-140"
                                :options="contractCurrencies(item)"
                                v-model="item.contractCurrency">
                  </dropdown-new>
                </td>
                <td>
                  <input type="text" class="a-input" v-model="item.paymentCurrency"/>
                </td>
<!--                <td class="table-tab__border-right ">-->
<!--                  <input type="text" class="a-input" v-model="item.fixBynComment"/>-->
<!--                </td>-->


                <td>
                  <input type="text" class="a-input" v-model="item.bidRuleComment"/>
                </td>
                <td>
                  <dropdown-new class="select-w-140"
                                :options="enums.BidRuleType.options.all"
                                v-model="item.type">
                  </dropdown-new>
                </td>
                <td>
                  <input type="text" class="a-input" v-model="item.bidRuleUserComment"/>
                </td>
                <td>
                  <dropdown-new class="select-w-140"
                                :options="enums.CurrencyClause.options.all"
                                v-model="item.currencyClause">
                  </dropdown-new>
                </td>
                <td>
                  <dropdown-new class="select-w-100-percent"
                                :options="enums.FixDateChoice.options.mandatory"
                                v-model="item.fixDate">
                  </dropdown-new>
                </td>
                <td>
                  <dropdown-new class="select-w-100-percent"
                                :options="enums.PaymentDateChoice.options.mandatory"
                                v-model="item.paymentDate">
                  </dropdown-new>
                </td>
                <td>
                  <input type="checkbox" v-model="item.allowAdvance">
                </td>
                <td></td>
              </template>
              <template v-else>
                <th class="table-tab__th table-tab__th--row">
                  {{i + 1}}
                </th>

                <td>
                  <label class="a-input--disabled">{{$t(item.status.label)}}</label>
                </td>
                <td>
                  <label class="a-input--disabled">{{$t(item.bidCurrency.label)}}</label>
                </td>
                <td>
                  <label class="a-input--disabled" v-if="item.contractCurrency.BYN">{{$t(item.contractCurrency.label)}}</label>
                  <label class="a-input--disabled" v-else>{{$t('form.catalogs.catalog-type.present-price.currency.the-same')}}</label>
                </td>
                <td>
                  <label class="a-input--disabled">{{item.paymentCurrency}}</label>
                </td>
<!--                <td class="table-tab__border-right ">-->
<!--                  <label class="a-input&#45;&#45;disabled">{{item.fixBynComment}}</label>-->
<!--                </td>-->
                <td>
                  <label class="a-input--disabled">{{item.bidRuleComment}}</label>
                </td>
                <td>
                  <label class="a-input--disabled">{{$t(item.type.label)}}</label>
                </td>
                <td>
                  <label class="a-input--disabled">{{item.bidRuleUserComment}}</label>
                </td>
                <td>
                  <p class=" a-input--disabled">{{$t(item.currencyClause.label)}}</p>
                </td>
                <td>
                  <label class=" a-input--disabled">{{$t(item.fixDate.label)}}</label>
                </td>
                <td>
                  <label class=" a-input--disabled">{{$t(item.paymentDate.label)}}</label>
                </td>
                <td>
                  <input type="checkbox" v-model="item.allowAdvance" disabled>
                </td>
                <td></td>
              </template>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div class="table-tab__btn-end" v-if="canEditRules">
      <button type="button" @click.prevent="onAddItemClick">
        <img src="@/assets/img/static/b-icon_plus-str.svg" alt="">
        {{$t('buttons.add-position-to-specification')}}
      </button>
    </div>
    <loading v-if="loading"></loading>
  </div>
  </section>
</template>

<script>
  import $ from 'jquery'

  let uniqueId = Date.now();

  export default {
    data: () => ({
      hasEditable: null,
      backup: undefined
    }),

    computed: {
      permissions() {
        return this.$store.getters.currentUser.permissions;
      },

      canEditRules() {
        return this.permissions.CAN_VIEW_ADMIN;
      },

      items() {
        return this.$store.getters.bidRules.items;
      },

      info() {
        return this.items;
      }
    },

    async created() {
      this.runAction(async () => {
        try {
          await this.$store.dispatch('fetchBidRulesFromCatalog');
        }
        catch(e) {
          console.error(e);
        }
      });
    },

    mounted() {
      this._updateTableRowsHeight();
    },

    updated() {
      this._updateTableRowsHeight();
    },

    methods: {
      contractCurrencies(item) {
        const currencies = [{id: this.enums.BynOrAnotherCurrency.BYN, name: 'currency.byn'}];

        if (item.bidCurrency.valueOf() === this.enums.BynOrAnotherCurrency.NOT_BYN) {
          currencies.push({id: this.enums.BynOrAnotherCurrency.NOT_BYN, name: 'form.catalogs.catalog-type.present-price.currency.the-same'})
        }
        else {
          currencies.push({id: this.enums.BynOrAnotherCurrency.NOT_BYN, name: 'currency.not-byn'})
        }

        return currencies;
      },

      onAddItemClick() {
        if (this.hasEditable) {
          return
        }

        this.hasEditable = { row: this.info.length };

        this.info.push({
          editable: true,
          bidCurrency: this.enums.BynOrAnotherCurrency.BYN,
          contractCurrency: this.enums.BynOrAnotherCurrency.BYN,
          bidRuleComment: undefined,
          bidRuleUserComment: undefined,
          currencyClause: this.enums.CurrencyClause.APPLICABLE,
          fixBynComment: undefined,
          fixDate: this.enums.FixDateChoice.VARIANT1,
          paymentCurrency: undefined,
          paymentDate: this.enums.PaymentDateChoice.VARIANT1,
          status: this.enums.CatalogPersonStatus.RESIDENT,
          type: this.enums.BidRuleType.A
        });
      },

      deleteItem(rowId) {
        this.runAction(async() => {
          try {
            await this.$store.dispatch('deleteBidRuleFromCatalog', this.items[rowId]);
          }
          catch(e) {
            this.showError({title: 'Ошибка', error: 'Что-то пошло не так'});
          }
        });
      },

      editItem(rowId) {
        this.hasEditable = { row: rowId };

        const item = this.info[rowId];
        this.backup = {...item};
        item.editable = true;

        this.$set(this.items, rowId, item);
      },

      async confirmEditable(rowId) {
        const item = this.info[rowId];
        const isNew = item.id === undefined;

        this.runAction(async () => {
          try {
            if (isNew) {
              await this.$store.dispatch('addBidRuleToCatalog', item);
            }
            else {
              await this.$store.dispatch('modifyBidRuleInCatalog', item);
            }
            this.hasEditable = null;
          }
          catch(e) {
            console.error('unable to add/modify file extension in catalog', e);
            this.globalErrorHandler(e)
          }
        });
      },

      cancelEditable(rowId) {
        const item = this.items[rowId];
        const isNew = item.id === undefined;

        if (isNew) {
          this.items.splice(rowId, 1);
        }
        else {
          this.$set(this.items, rowId, this.backup);
        }
        this.hasEditable = null;
      },

      _updateTableRowsHeight() {
        const dataRows = $(this.$el).find('.table-tab__container .table-tab__row-auto-height');
        const controlRows = $(this.$el).find('.table-tab__actions-block .table-tab__row-auto-height');

        if (dataRows.length !== controlRows.length) {
          console.error('amount of data and control rows should be the same');
          return;
        }

        for (let i = 0; i < dataRows.length; ++i) {
          const $d = $(dataRows[i]);
          const $c = $(controlRows[i]);

          const height = Math.max($d.height(), $c.height());

          $d.height(height);
          $c.height(height);
        }
      },
    }
  }
</script>

<style scoped>

</style>
